import { render } from "./new_stack_p3_A.vue?vue&type=template&id=49b71a93&scoped=true"
import script from "./new_stack_p3_A.vue?vue&type=script&lang=js"
export * from "./new_stack_p3_A.vue?vue&type=script&lang=js"

import "./new_stack_p3_A.vue?vue&type=style&index=0&id=49b71a93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b71a93"]])

export default __exports__